import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxStudent from '../util/remote/ajaxStudent';

const initialState = { 
    metaData: null,
    currentPage: 1,
    listing: null,
    mounted: false,
    classId: '0',
    residenceId: '0',
    searchText: '',
    streamId: '',
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const ContactContext = createContext();

export const ContactProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filterClass, setFilterClass] = useState(null);


   /**
   * Only call this if the getTransactions has already been called on mount by the AccountStatementPage
   */
  useEffect(()=>{
    if(state.mounted){
      getContacts();
    }
  }, [state.currentPage])


  const getContacts = async (refresh = false, classId = null) => {
    dispatch({ type: "mounted", payload: true });
    setFilterClass(classId);
    if (refresh) {
        dispatch({ type: "listing", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
    }
    const payload = {
        page: refresh ? 1 : state.currentPage,
        class_id: classId ?? state.classId,
        residence_id: state.residenceId,
        search_text: state.searchText,
        stream_id: state.streamId,
    };
    const server_response = await ajaxStudent.getStudents(payload);
    if (server_response.status === "OK") {
        const newTransactions = server_response.details.data;

        dispatch({
            type: "listing",
            payload: refresh ? newTransactions
                    : state.listing
                    ? [...state.listing, ...newTransactions]
                    : newTransactions
        });

        dispatch({ type: "metaData", payload: server_response.details.meta });
    } else {
        dispatch({ type: "listing", payload: "404" });
        dispatch({ type: "metaData", payload: "404" });
    }
 };

 const filter = async()=>{
    await getContacts(true, state.classId);
  }

  

 const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
 }
  




  return(
    <ContactContext.Provider value={{
      ...state,
      filterClass,
      dispatch,
      getContacts,
      setCurrentPage,
      setFilterClass,
      filter,
      }}>
      {children}
    </ContactContext.Provider>
  )

}

export const useContact = ()=>useContext(ContactContext);

